import { useEffect } from 'react'

import Grid from '../components/grid'
import { setCurrentPath } from '../state/ui'
import { useMovies } from '../queries/media'
import { castSend } from '../tools/cast'

export default function Movies() {
  const { data, fetchNextPage, hasNextPage, isFetchingNextPage } = useMovies()

  useEffect(() => {
    castSend({ type: 'home' }, true)
    setCurrentPath([])
  }, [])

  return (
    <Grid
      shows={data ?? []}
      infiniteFunc={() => {
        if (hasNextPage && !isFetchingNextPage) fetchNextPage()
      }}
    />
  )
}
